"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var rxjs_1 = require("rxjs");
var log_session_model_1 = require("../models/log-session.model");
var LoggingService = /** @class */ (function () {
    function LoggingService(http) {
        this.http = http;
        this.disableLogging = false;
        this.session = new log_session_model_1.LogSession();
    }
    LoggingService.prototype.logEvent = function (event) {
        if (this.disableLogging)
            return;
        var logData = __assign({}, this.session, event);
        this.http
            .post('/api/proactive/LogEvent', logData)
            .pipe(operators_1.catchError(function (error) {
            if (error.error instanceof ErrorEvent) {
                console.error('An error occurred:', error.error.message);
            }
            else {
                console.error("Server error occurred (" + error.status + ").  Body was: " + JSON.stringify(error.error));
            }
            return rxjs_1.throwError('Failed to log Proactive chat event details');
        }))
            .subscribe(function () {
            console.log("Successfully log Proactive chat event details.", logData);
        });
    };
    LoggingService.prototype.updateChatContext = function (context) {
        this.session.ExternalSessionCode = context.sessionId;
        this.session.ReportingTag = context.chatRuleData.ReportingTag;
        this.session.SourceUrl = context.location.pathname;
        this.session.SourceUrlTitle = context.title;
    };
    return LoggingService;
}());
exports.LoggingService = LoggingService;
